
































import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import AbpBase from "@/lib/abpbase"
// import URL from '../../../lib/url'
// import {XMLHTTP_BASEURL} from '../../../../public/config.js'


@Component({})
export default class UpLoad extends AbpBase {
	@Prop() piclist: any;

	//列表变化，图片信息带出
	@Watch('uploadList')
	WatchuploadList(val: any, oldVal: any) {
		this.$emit('on-confirm', this.uploadList)
	}

	defaultList = []
	imgName = ''
	visible = false
	uploadList = []
	files = []
	visibleSrc = ''
	loadingStatus = false

	mounted() {
		console.log(this.piclist)
		if (this.piclist.list) {
			this.piclist.list.forEach((item:any) => {
				this.uploadList.push({
					name: item.name,
					url: item.imgUrl,
				})
			});
		}

		// this.uploadList = (this.$refs.upload as any).fileList;
	}

	get Url() {
		return XMLHTTP_BASEURL;
	}

	handleView(name:any, oldImgName:any, src:any) {
		this.visibleSrc = src
		this.imgName =  name;
		this.visible = true;
	}

	handleRemove(index:any) {
		// const fileList = (this.$refs.upload as any).fileList;
		// (this.$refs.upload as any).fileList.splice(fileList.indexOf(file), 1);
		this.uploadList.splice(index, 1);
		// console.log(this.files)
	}

	handleSuccess(res:any, file:any) {
		if (res.result.objects.imageAddress) {
			this.uploadList.push({
				name: file.name,
				url: res.result.objects.imageAddress,
			})
		}
	}

	handleFormatError(file:any) {
		this.$Notice.warning({
			title: 'The file format is incorrect',
			desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
		});
	}

	handleMaxSize(file:any) {
		this.$Notice.warning({
			title: 'Exceeding file size limit',
			desc: 'File  ' + file.name + ' is too large, no more than 2M.'
		});
	}

	handleBeforeUpload(file:any) {
		// const check = this.uploadList.length < 5;
		// if (!check) {
		//     this.$Message.info('最多可上传5张图片');
		//     return false;
		// }
		//本地存储file对象
		// this.files.push(file)
		// // 创建一个 FileReader 对象
		// let reader = new FileReader()
		// // readAsDataURL 方法用于读取指定 Blob 或 File 的内容
		// // 当读操作完成，readyState 变为 DONE，loadend 被触发，此时 result 属性包含数据：URL（以 base64 编码的字符串表示文件的数据）
		// // 读取文件作为 URL 可访问地址
		// reader.readAsDataURL(file)
		// const _this = this
		// reader.onloadend = function (e) {
		//     file.url = reader.result
		//     _this.uploadList.push({
		//         name: file.name,
		//         percentage: 100,
		//         status:"finished",
		//         uid: file.lastModified,
		//         url:file.url
		//     })
		//     console.log(_this.uploadList)
		// }
		// return false;

	}

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/medDocs/parts/upload.vue